import { handleResponseError } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Overlay } from './models/overlay';
import overlayService from './overlayService';
import { overlayActions } from './overlaySlice';

function* fetchOverlayList() {
  try {
    const response: CommonResponse<Overlay[]> = yield call(overlayService.getAll);
    yield put(overlayActions.fetchOverlayListSuccess(response));
  } catch (e) {
    yield put(overlayActions.fetchOverlayListFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* overlaySaga() {
  yield takeLatest(overlayActions.fetchOverlayList.type, fetchOverlayList);
}
